export default function Drawer(theme) {
  return {
    MuiDrawer: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.default
        },
        paper: {
          backgroundColor: '#fff',
          borderRight: `1px solid ${theme.palette.divider}`,
          borderRadius: '0px',
          boxShadow: 'none',
          color: theme.palette.secondary.contrastText,
          width: 280,
          boxSizing: 'border-box',
          overflowY: 'auto',
          overflowX: 'hidden',
          // Remove ListItem overrides from Drawer - handled by Navigation override
          '&::-webkit-scrollbar': {
            width: '6px'
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.primary.dark,
            borderRadius: '3px'
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent'
          }
        }
      }
    }
  };
} 